@if (browseTerms && browseTerms.length) {
  <div>
    <div class="browse-data">
      <table class="table table-sm table-hover">
        <thead class="thead">
          <tr>
            <th>Item Call Number</th>
            <th>Title</th>
            <th>Title Count</th>
          </tr>
        </thead>
        <tbody>
          @for (browseTerm of browseTerms; track browseTerm; let i = $index) {
            <tr tabindex="0" (agInteract)="search(browseTerm)">
              <td class="w-15">{{ browseTerm.searchTerm }}</td>
              <td class="w-40">{{ browseTerm.title }}</td>
              <td class="w-40">
                [{{ browseTerm.hitCount }} {{ browseTerm.hitCount === 1 ? 'Title' : 'Titles' }}]
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
